export default {

  // 商品评价列表
  getEvaluationList(params, success) {
    Request.GET('/commodity/evaluation', params, response => success(response));
  },

  // 商品评价详情
  getEvaluationDetail(params, success) {
    Request.GET(`/commodity/evaluation/${params}`, null, response => success(response));
  },

  // 商品评价删除
  deleteEvaluation(params, success) {
    Request.DEL(`/commodity/evaluation/${params}`, null, response => success(response));
  },
};



// WEBPACK FOOTER //
// ./src/api/evaluationApi.js